import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

const Layout = () => {
    const [isProgrammaticScroll, setIsProgrammaticScroll] = useState(false);
    const location = useLocation();

    return (
        <>
            <Navbar 
                isProgrammaticScroll={isProgrammaticScroll} 
                setIsProgrammaticScroll={setIsProgrammaticScroll} 
            />
            <main>
                <Outlet />
            </main>
            {location.pathname === '/' && <Footer />}
        </>
    );
};

export default Layout;